import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#292A2E",
      d: "m7 10.652-4.114 2.303.918-4.625L.342 5.129l4.683-.556L7 .292l1.975 4.281 4.683.556-3.463 3.201.92 4.625zm0-1.337L9.477 10.7l-.553-2.784 2.084-1.928-2.82-.334L7 3.077 5.81 5.655l-2.82.334 2.085 1.928-.554 2.784z"
    }, null, -1)
  ]))]))
}
export default { render: render }